<template>
    <div>
        <breadcrumbs
            :title="'Vrste tema'"
            :breadcrumbs="breadcrumbs"
        ></breadcrumbs>
        <div class="ibox">
            <div class="ibox-title">
                <h5>Nova vrsta teme</h5>
            </div>
            <div class="ibox-content">
                <vrsta-teme-forma
                    :disabled="false"
                    :id="null"
                    :modal="false"
                    :action="'create'"
                ></vrsta-teme-forma>
            </div>
        </div>
    </div>
</template>

<script>
import Breadcrumbs from "../../../../components/breadcrumbs/Breadcrumbs";
import VrstaTemeForma from "./VrstaTemeForma";
export default {
    name: "VrstaTemeCreate",
    components: {
        VrstaTemeForma,
        Breadcrumbs
    },
    data(){
        return {
            breadcrumbs: []
        }
    },
    methods: {
        setBreadcrumbs(){
            this.breadcrumbs = [
                {
                    path: '/postavke/vrste-tema',
                    name: 'Vrste tema'
                },
                {
                    path: '/postavke/vrste-tema/create',
                    name: 'Nova vrsta teme'
                }
            ]
        }
    },
    mounted(){
        this.setBreadcrumbs()
    }
};
</script>

<style scoped>

</style>
